import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {LanguageService} from '../../../services/language.service';
import {
  OfferModificationsService
} from '../../../../core/services/impl/offer-modifications/offer-modifications.service';
import {OfferModification} from '../../../../core/models/offer/offer-modification.model';
import {OfferModificationCode} from '../../../../core/consts/offer-modification-code.enum';
import {AcVariantsSectionConfig} from '../ac-variants-section/ac-variants-section.config';
import {OfferModificationDestination} from '../../../../core/consts/offer-modification-destination.enum';
import {RegistrationService} from '../../../../core/services/impl/registration.service';
import {Offer} from '../../../../core/models/offer/offer.model';
import {MatDialog} from '@angular/material';
import {
  AssistanceCoveragesComparisonComponent
} from './assistance-coverages-comparison/assistance-coverages-comparison.component';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {ScrollHelper} from '../../../services/scroll-helper';
import { BusinessParamName } from '../../../models/request-offer/request-offer.enum';
import { InsuranceCompanyCode } from '../../../models/insurance-company-code.enum';
import { ApplicationStateService } from '../../../services/application-state.service';
import { Subscription } from 'rxjs/Rx';
import {isKIOSKPOLIS, noop} from '../../../../core/utils/utils';
import {SelectComponent} from '../../../components/fields/ng-multiselect/select.component';
import {BannersService} from '../../../services/banners.service';
import {
  OfferModificationConfig,
  OfferModificationsConfigService
} from '../../../../core/services/impl/offer-modifications/offer-modifications-config.service';
import {
  LoadingContentPlaceholderCellSize,
  LoadingContentPlaceholderConfig,
  LoadingContentPlaceholderType
} from '../../../components/presentation/loading-content-placeholder/loading-content-placeholder.component';

@Component({
  selector: 'app-additional-options-section',
  templateUrl: './additional-options-section.component.html',
  styleUrls: ['./additional-options-section.component.scss']
})
export class AdditionalOptionsSectionComponent extends SectionBase implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('select') select: SelectComponent;

  modificationsConfigs: OfferModificationConfig[];
  modifications: OfferModification[];
  allModificationsVisible: boolean;
  sectionVisible: boolean = false;
  premiumEventSubscription: Subscription;
  expandModificationsButtonVisible: boolean;
  contentVisible: boolean = true;
  loadingContentPlaceholderConfig: LoadingContentPlaceholderConfig = {
    type: LoadingContentPlaceholderType.ADVANCED,
    rows: [
      {
        cells: [
          {
            size: LoadingContentPlaceholderCellSize.SMALL
          },
          {
            size: LoadingContentPlaceholderCellSize.LARGE
          },
          {
            size: LoadingContentPlaceholderCellSize.LARGE
          },
          {
            size: LoadingContentPlaceholderCellSize.LARGE
          }
        ]
      },
      {
        cells: [
          {
            size: LoadingContentPlaceholderCellSize.SMALL
          },
          {
            size: LoadingContentPlaceholderCellSize.LARGE
          },
          {
            size: LoadingContentPlaceholderCellSize.LARGE
          },
          {
            size: LoadingContentPlaceholderCellSize.LARGE
          }
        ]
      },
      {
        cells: [
          {
            size: LoadingContentPlaceholderCellSize.SMALL
          },
          {
            size: LoadingContentPlaceholderCellSize.LARGE
          },
          {
            size: LoadingContentPlaceholderCellSize.LARGE
          }
        ]
      }
    ]
  }

  ModificationCode = OfferModificationCode;

  private readonly MODIFICATIONS_ORDER = [
    OfferModificationCode.ASSISTANCE,
    OfferModificationCode.NNW,
    OfferModificationCode.GLASS,
    OfferModificationCode.PRICE_LOSS,
    OfferModificationCode.GREEN_CARD,
    OfferModificationCode.TIRES,
    OfferModificationCode.REPLACEMENT_CAR,
    OfferModificationCode.LUGGAGE,
    OfferModificationCode.MEDIC,
  ];

  get visibleModifications(): OfferModification[] {
    return this.modifications.filter(mod => mod.visible);
  }

  get invisibleModifications(): OfferModification[] {
    return this.modifications.filter(mod => !mod.visible);
  }

  get selectedOffer(): Offer {
    return this.offerModificationsService.selectedOfferService.selectedOffer;
  }

  get buttonVisible(): boolean {
    return !this.offerModificationsService.offerCurrentPrice;
  }

  get bannerVisible(): boolean {
    return this.sectionVisible && this.bannersService.paymentBannerVisible && isKIOSKPOLIS();
  }

  get validInsuranceCompany(): boolean {
    return [InsuranceCompanyCode.UNIQA, InsuranceCompanyCode.PEVNO].includes(this.stateService.getBusinessParameterValue(BusinessParamName.INSURANCE_COMPANY_CODE) as InsuranceCompanyCode);
  }

  get isGetOfferRequired(): boolean {
    // TODO update requirement based on configuration or offer's business parameter
    return [InsuranceCompanyCode.UNIQA, InsuranceCompanyCode.PEVNO].includes(this.stateService.getBusinessParameterValue(BusinessParamName.INSURANCE_COMPANY_CODE) as InsuranceCompanyCode);
  }

  constructor(private languageService: LanguageService,
              private bannersService: BannersService,
              private registration: RegistrationService,
              private cdr: ChangeDetectorRef,
              private dialog: MatDialog,
              private stateService: ApplicationStateService,
              public offerModificationsService: OfferModificationsService,
              private configService: OfferModificationsConfigService) {
    super();
  }

  ngOnInit() {
    this.init();
    const subscription = this.offerModificationsService.getOfferEvent.subscribe(() => {
      subscription.unsubscribe();
      this.init();
    });
  }

  ngOnDestroy(): void {
    this.offerModificationsService.unsubscribeFromEvents();
    this.premiumEventSubscription ? this.premiumEventSubscription.unsubscribe() : noop();
  }

  ngAfterViewInit(): void {
    // setTimeout(() => this.initRecalculateButtonBehaviour(), 0);
  }

  createConfig(): void {
    const priceFrequency = this.offerModificationsService.getCorrectPriceFrequency();
    const config = new AcVariantsSectionConfig(this.languageService, this.offerModificationsService, priceFrequency);
    this.formConfig = config.createConfig(OfferModificationDestination.ADDITIONAL_OPTIONS, this.modifications, true);
  }

  initBean(): void {
    this.bean = {};
    this.modifications.forEach(modification => {
      const selectedOption = modification.options.find(option => option.selected);
      if (selectedOption) {
        this.bean[modification.code] = selectedOption.value;
        if (this.offerModificationsService.isModificationWithSelect(modification.code)) {
          let selectValue;
          switch (modification.code) {
            case OfferModificationCode.NNW:
              selectValue = selectedOption.value > 0 ? selectedOption.value : Math.min(...modification.options.map(option => option.value).filter(value => value > 0));
              break;
            case OfferModificationCode.GLASS:
              selectValue = selectedOption.value !== 'NONE' ? selectedOption.value : this.offerModificationsService.getOptionWithMinimumNonZeroPrice(modification)
                  .value;
              break;
          }
          this.bean[`${modification.code}-value`] = selectValue;
        }
      }
    });
  }

  initControlsChanges(): void {
    this.modifications.forEach(modification => this.getControl(modification.code).valueChanges.subscribe(value => {
      this.offerModificationsService.updateModification(modification.code, value);
      this.offerModificationsService.additionalOptionsModified = true;
      this.offerModificationsService.setOfferCurrentPrice();
      this.offerModificationsService.modifiedOfferEvent.emit();
    }));

    if (isNotNullOrUndefined(this.getControl('NNW-value'))) {
      this.getControl('NNW-value').valueChanges.subscribe(value => {
        this.offerModificationsService.nnwValue = value;
        this.offerModificationsService.updateModification(OfferModificationCode.NNW, value);
        this.offerModificationsService.additionalOptionsModified = true;
        this.rebuildSection();
        this.getControl(OfferModificationCode.NNW).setValue(value, {emitEvent: false});
        this.offerModificationsService.setOfferCurrentPrice();
        this.offerModificationsService.modifiedOfferEvent.emit();
      });
    }

    if (isNotNullOrUndefined(this.getControl('GLASS-value'))) {
      this.getControl('GLASS-value').valueChanges.subscribe(value => {
        this.offerModificationsService.glassValue = value;
        this.offerModificationsService.updateModification(OfferModificationCode.GLASS, value);
        this.offerModificationsService.additionalOptionsModified = true;
        this.rebuildSection();
        this.getControl(OfferModificationCode.GLASS).setValue(value, {emitEvent: false});
        this.offerModificationsService.setOfferCurrentPrice();
        this.offerModificationsService.modifiedOfferEvent.emit();
      });
    }
  }

  toggleVisibility(): void {
    this.allModificationsVisible = !this.allModificationsVisible;
  }

  compareCoverages(): void {
    this.dialog.open(AssistanceCoveragesComparisonComponent, AssistanceCoveragesComparisonComponent.getConfigBuilder()
        .buildConfiguration(this.offerModificationsService.getAssistancePricing()))
        .afterClosed().subscribe(assistanceVariant => {
          if (isNotNullOrUndefined(assistanceVariant)) {
            this.getControl(OfferModificationCode.ASSISTANCE).setValue(assistanceVariant);
          }
    });
  }

  recalculatePremium(): void {
    this.offerModificationsService.recalculatePremium();
  }

  onSelectInteractiveClick(): void {
    this.parentSection.sendCheckoutElementClickEvent({
      fieldLabel: this.select.formFieldService.fieldCaptionTranslated(this.getFieldConfig(OfferModificationCode.NNW))
    });
  }

  private init(): void {
    this.initModifications();
    this.initSectionVisible();
    if (this.contentVisible) {
      this.initBean();
      this.createConfig();
      this.buildForm();
      this.initControlsChanges();
      this.offerModificationsService.setOfferBasicPrice();
      this.offerModificationsService.setOfferCurrentPrice();
      this.offerModificationsService.initCache();
      this.premiumEventSubscription = this.registration.premiumChangeEvent.subscribe(() => {
        this.offerModificationsService.setOfferCurrentPrice();
        this.rebuildSection()
      });
    }
  }

  private sortModifications(): any {
    const sortedModifications = [];
    this.MODIFICATIONS_ORDER.forEach(modificationCode => {
      const modification = this.modifications.find(mod => mod.code === modificationCode);
      if (isNotNullOrUndefined(modification)) {
        sortedModifications.push(modification)
      }
    });
    this.modifications = sortedModifications;
  }

  private initModifications(): void {
    this.modificationsConfigs = this.configService.getModificationsForDestination(OfferModificationDestination.ADDITIONAL_OPTIONS);
    const codes = this.modificationsConfigs.map(config => config.code);
    if (this.offerModificationsService.modifications && this.offerModificationsService.modifications.length > 0) {
      this.modifications = this.offerModificationsService.modifications.filter(modification => codes.includes(<OfferModificationCode>modification.code));
      this.expandModificationsButtonVisible = this.modifications.map(mod => mod.visible)
          .filter(visible => !visible)
          .length > 1;
      this.allModificationsVisible = !this.expandModificationsButtonVisible;
      this.offerModificationsService.nnwValue = this.offerModificationsService.selectedNNWOption ? this.offerModificationsService.selectedNNWOption.value : null;
      this.offerModificationsService.glassValue = this.offerModificationsService.getSelectedOption(OfferModificationCode.GLASS) ? this.offerModificationsService.getSelectedOption(OfferModificationCode.GLASS).value : null;
      this.sortModifications();
    }
  }

  private initSectionVisible(): void {
    if (this.offerModificationsService.requiresGetOffer) {
      this.sectionVisible = this.validInsuranceCompany;
      this.contentVisible = this.sectionVisible && this.modifications && this.modifications.length > 0;
    } else {
      this.sectionVisible = this.validInsuranceCompany && this.modifications && this.modifications.length > 0;
      this.contentVisible = this.sectionVisible;
    }
  }

  private rebuildSection(): void {
    this.initBean();
    this.createConfig();
    this.buildForm();
  }

  private initRecalculateButtonBehaviour(): void {
    const scrollHelper = new ScrollHelper();
    scrollHelper.registerScrollEventVisibiltyHandler({
      elementToHideSelector: '#recalculate-btn',
      visibleElementSelector: '#wizard-recalculate-btn',
      threshold: 0.01
    })
  }

}
